import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { ActionSheetController, IonContent, NavController, Platform, IonRouterOutlet } from '@ionic/angular';
import { Router, ActivatedRoute, NavigationExtras, RoutesRecognized } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { HelperService } from 'src/app/services/helper.service';
import { filter, pairwise } from 'rxjs/operators';
import { JsonpClientBackend } from '@angular/common/http';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.page.html',
  styleUrls: ['./product-detail.page.scss'],
})
export class ProductDetailPage implements OnInit {
  @ViewChild(IonContent) content: IonContent;
  productId: any;
  check: any = 0;
  promotionId: any;
  productDetail: any = {};
  productQty: any;
  userId: any;
  finalPayAmount: any;
  productDelDate: any;
  isPromoActiveFlag: any;
  selectColorOption: any;
  selectSizeOption: any;
  previousUrl: any;
  qty: number = 1;
  backPageFlag: any = {};
  wishlistFlag: boolean = false;
  recommendedProducts: any = [];
  rate: any;
  poor: any;
  average: any;
  good: any;
  verygood: any;
  excellent: any;
  review: any;
  review1: any;
  city = localStorage.getItem('city');
  pin: any;
  skipRole: any;
  productList: any = [];
  spotCoins: any;
  spotcash: any;
  item: any;
  index: any;
  userAddress: string = ''
  userLatitude: string = ''
  userLongitude: string = ''
  addressDisplay: any;
  googlemap: any;
  isItemAvailable: boolean;
  ipaddress: any;
  catslideOptions = {
    initialSlide: 1,
    slidesPerView: 2.5,
    autoplay: false,
    //spaceBetween: "20",
  };
  wishlist: any = [];
  cart: any = [];
  show: any;
  variant: boolean;
  variantsid: any;
  color: any;
  size: any;
  variantprice: any = [];
  s: any;
  n:any=0
  variantProperties: any = {};
  selectedOptions: any = {};
  price: any;
  loaded: boolean = false;
  offersslideOptions = {
    initialSlide: 0,
    slidesPerView: 1,
    autoplay : false,
    loop : true,
    pager : true
  };
  a:boolean=false;
  multipleImages : any=[];
  currentStatus:boolean;
  fetchVarientData:any;
  multipleImagesofProduct=[
    {image:"../assets/imgs/multiimage/img.jpg"},
    {image:"../assets/imgs/multiimage/img1.jfif"},
    {image:"../assets/imgs/multiimage/img3.jfif"},
  ]
  selectedImage:any;
  selectSingleImage:any=this.multipleImagesofProduct[0].image;
  addedToWishlist: any;
  middleImgbottom: any;
  constructor(private service: StoreService,
    private toast: HelperService,
    private platform: Platform,
    private routerOutlet: IonRouterOutlet,
    private router: Router,
    private routerActivate: ActivatedRoute,
    private navController: NavController,
    private toastt: ToastService,
    private userService: UserService,private toastService: ToastService,
    private ngZone: NgZone,@Inject(DOCUMENT) private document: Document) {
      this.userService.cartUpdated.subscribe(res => {
        let cart = localStorage.getItem('cart');
        if(cart){
          this.n = JSON.parse(cart).length;
        }
      })
    }

  ngOnInit() {
    let that = this;
    // this.platform.backButton.subscribeWithPriority(9999, () => {
    //     console.log('hello');
    //   document.addEventListener('backbutton', function(event) {

    //     if (that.router.url.includes('product-detail')) {
    //       // this.platform.exitApp(); 
    //     } else {
    //       if (that.routerOutlet && that.routerOutlet.canGoBack()) {
    //         that.routerOutlet.pop();
    //       }
    //     }
    //   }, false);
    // });
    this.userId = localStorage.getItem('userId')
  
  }

  ionViewWillEnter() {
    console.log(this.routerActivate.snapshot.params.id)
    this.productId = this.routerActivate.snapshot.params.id;

    this.userId = localStorage.getItem('userId')
    this.review = null;
    this.review1 = null;
    this.recommendedProducts = [];
    console.log(this.backPageFlag);

    console.log("hit product Detail page")
    this.detailOfProduct(this.promotionId, this.productId)
    this.recommandedProductList();
    this.getProductRate();
  }

  detailOfProduct(promoId: any, productId: any) {

    //this.authService.showLoader()
    this.productId = productId;
    const promoListobj = {
      promotionId: promoId,
      productId: productId,
      
    }
    console.log("promoListobj",promoListobj)
    this.service.fetchProductDetail(promoListobj).subscribe((result: any) => {
      if(result){
        this.productId=result._id
        localStorage.setItem("productId", this.productId)
        console.log("dsfdgffffffffffffff", this.productId)
      }
      this.service.pDetail = result
      this.productDetail = this.service.pDetail;
      this.multipleImages=this.productDetail?.multipleImages

      console.log("result",result)
      this.loaded = true;
      console.log(this.loaded)
    this.variant=result.variantId;
     this.getVarienct( this.variant);
      // this.variant=result.hasVariant;
      //this.wishlistFlag = this.productDetail.wishlisted;
      //this.spotCoins = result.ConsumerInfo.spotCoins;
      //this.spotcash = result.ConsumerInfo.spotCash;

      if (result.variants) {
        this.variantsid = result.variants.variantIds;
        this.variantprice = result.variants.variantPrices;
        this.variantsid.forEach(x => {
          console.log("x ", x)
          let arr = [];
          this.variantprice.forEach(element => {
            console.log("element ", element)
            console.log("element[x] ", element[x])
            arr.push(element[x]);
          });
          this.variantProperties[x] = arr;

        })

        console.log(this.variantProperties)
      }

      //  this.color=this.variantsid.find(element=> 'Color')
      //  this.size=this.variantsid.find(element=>'Size')
      // console.log("color",this.color);
      // console.log("size",this.size);
      console.log("response from product detail API", this.productDetail)
      // var today = new Date();
      // console.log("delivery date", this.productDetail.deliveryDate)
      // today.setDate(today.getDate() + parseInt(this.productDetail.deliveryDate));
      // console.log("date", today)
      // this.productDelDate = today.toISOString();
      //this.authService.hideLoader()
    }, (error: any) => {
      console.log("error log", error)

    });
  }

   getVarienct(id_:any)
  {
    let formdata={
      "id":id_
    }
    console.log("has variant formdata",formdata)
    this.service.hasVariantDetail(formdata).subscribe((result: any) => {
      this.currentStatus=true
      this.fetchVarientData = result;
    });
  }
  onChange(value){
    value.isButtonActive = true;
    console.log("Value from selected varient",value)
    this.productDetail=value
  }



  goBack() {
    this.navController.back();
  }
  middleBannerImage(city:any) {
    let that = this;
    const DisObj = {
      city: city
    }
    this.service.middleBannerImg1(DisObj).subscribe((result: any) => {

      this.ngZone.run(() => {
        console.log("result ", result)
        that.middleImgbottom = result;
        console.log("that.middleImgbottom ", that.middleImgbottom)
      });
  
    }, (error: any) => {

    });
   
  }
  goHome() {
    this.router.navigate(['/'])
  }
  ionViewDidLeave() {
    this.productDetail = {}
    this.selectColorOption = "";
    this.selectSizeOption = "";
    this.qty = 1
  }
  selectColor(e) {
    console.log(this.selectColorOption, "color")
  }
  selectSize(e) {

    console.log(this.selectSizeOption, "size")
  }
//Added by Divyansh Sharma for product variants
  test(ev, selectedOptions) {
    console.log("testinf ", ev.detail);
    console.log("selectedOptions ", selectedOptions);
    var filtered = this.variantprice;
    if (this.variantsid.length == Object.keys(selectedOptions).length) {
      this.variantsid.forEach(x => {
        filtered = filtered.filter(a => a[x] == selectedOptions[x])
      })
    }
    this.price = filtered[0].Price;
    console.log(this.price, "jvgnhvbnvbn");

  }
  increment() {
    this.qty++;
  }

  decrement() {
    if (this.qty > 1) {
      this.qty--;
    }

  }

  //Added by Divyansh Sharma for add to cart productsc
  handleAddToCart(productObj) {
    console.log("productObj ", productObj)
    this.cart = []
    let cart = localStorage.getItem("cart");
    if (cart) {
      this.cart = JSON.parse(cart);
      console.log("cart ", this.cart)
      let filtered = this.cart.filter(product => product.id == productObj._id)
      console.log("filtered ", filtered)
      if (filtered.length == 0) {
        var pdata = {
          id: productObj._id,
          qty: this.qty
        }
        console.log(pdata)
        this.cart.push(pdata)
        localStorage.setItem('cart', JSON.stringify(this.cart))
        this.show = 1
      } else {
        console.log(this.show)
        let index = this.cart.indexOf(filtered[0]);
        console.log("index ", index)
        this.cart.splice(index, 1)
        localStorage.setItem('cart', JSON.stringify(this.cart))
        this.show = null

      }
    } else {
      console.log("item._id ", productObj._id)
      var pdata = {
        id: productObj._id,
        qty: this.qty
      }
      this.cart.push(pdata)
      localStorage.setItem('cart', JSON.stringify(this.cart))
      this.show = 1
    }
    this.userService.cartUpdated.next(true);
  }
  // handleAddToCart(productObj){
  //   delete productObj.qty;
  //   let promoListobj={
  //     productdetails:productObj,
  //     userId:this.userId
  //   }
  //   console.log("object delete qty key",productObj)
  //  // this.authService.addCartServices(APIS.addTocart,formdata,true)
  //  this.service.addToCart(promoListobj) 
  //  .subscribe((result: any) => {
  //     //this.messanger.sendMsg(productObj)
  //     this.toastt.presentToast("Product added in your cart")
  //    //this.loadCartItems()
  //    }, (error: any) => {    
  // });
  // }    


//Added by Divyansh Sharma for wishlist products
  // Wishlist(item: any) {
  //   let wishlist = localStorage.getItem('wishlist');
  //   if (wishlist) {
  //     this.wishlist = JSON.parse(wishlist);
  //     let index = this.wishlist.indexOf(item._id);
  //     if (index == -1) {
  //       this.wishlist.push(item._id)
  //       localStorage.setItem('wishlist', JSON.stringify(this.wishlist))
  //       // console.log(localStorage.getItem('wishlist'))
  //       this.s = 1;
  //     } else {
  //       this.wishlist.splice(index, 1)
  //       localStorage.setItem('wishlist', JSON.stringify(this.wishlist))
  //       this.s = null;
  //     }
  //   } else {
  //     console.log("item._id ", item._id)
  //     this.wishlist.push(item._id)
  //     localStorage.setItem('wishlist', JSON.stringify(this.wishlist))
  //     // console.log(localStorage.getItem('wishlist'))
  //     this.s = 1;
  //   }
  // }

///Added by Divyansh Sharma to check the wishlist item 
  wish(item){
    let wishlist = localStorage.getItem('wishlist');
    if (wishlist) {
      this.wishlist = JSON.parse(wishlist);
      let index = this.wishlist.indexOf(item._id);
      if (index == -1) {
        return true
  }else{
      return false
  }
}}

///Added by Divyansh Sharma to check the wishlist item 
  wish1(item){
    let wishlist = localStorage.getItem('wishlist');
    if (wishlist) {
      this.wishlist = JSON.parse(wishlist);
      let index = this.wishlist.indexOf(item._id);
      if (index == -1) {
        return false
  }else{
      return true
  }
}}


  WishlistNav() {
    this.router.navigate(['../wishlist'])
  }
  recommandedProductList() {
    this.recommendedProducts = [];
    let formdata = {
      productId: this.productId,
      city: this.city,
      zip: this.pin
    }
    this.service.recommendedProducts1(formdata).subscribe((result: any) => {
      // console.log("recommended Products",result[0].name)
      if(result){
        this.productId=result._id
        localStorage.setItem("productId", this.productId)
        console.log("dsfdgffffffffffffff", this.productId)
      }
      for (let i = 0; i < result.length; i++) {
        this.recommendedProducts.push(result[i]);
      }
      console.log("recommended products", this.recommendedProducts)
    }, (error: any) => {});
  }
  recommend() {
    let navigationParams: NavigationExtras = { state: { Reflag: 'recommend' } };
    this.router.navigate(['/home/recommend-product'], navigationParams);
  }
  onClick(productItem: any) {
    this.detailOfProduct(productItem.promotionId, productItem._id)
    document.body.scrollTop = 0;
    this.content.scrollToTop(1500);
    this.getProductRate();
    this.recommandedProductList()
    // let qty = 1;
    // // console.log("product item object clickable product", productItem);
    // let navigationParams: NavigationExtras = { state: { productId: productItem._id, promotionId: productItem.promotionId, productQty: qty, backPageFlag: { backPageFlagInfo: "6" } } };
    // this.router.navigate(['home/product-detail'], navigationParams);
  }

  ///added by Parul for getting rating of product
  getProductRate() {
    this.rate = null;
    this.poor = null;
    this.average = null;
    this.good = null;
    this.verygood = null;
    this.excellent = null;
    let promoListobj = {
      productId: this.productId
    }
    // this.authService.addCartServices(APIS.addTocart,formdata,true)
    console.log("get Product rating params ", promoListobj)
    this.service.getProductrating(promoListobj)
      .subscribe((result: any) => {
        //this.messanger.sendMsg(productObj)
        if (result.calculateAvergaeRating == null) {
          this.rate = 0;
        } else {
          this.rate = result.calculateAvergaeRating;
        }
        if (result.poor == 0) {
          this.poor = 0;
        } else {
          this.poor = result.poor / (result.poor + result.average + result.good + result.verygood + result.excellent)
        }
        if (result.average == 0) {
          this.average = 0;
        } else {
          this.average = result.average / (result.poor + result.average + result.good + result.verygood + result.excellent)
        }
        if (result.good == 0) {
          this.good = 0;
        } else {
          this.good = result.good / (result.poor + result.average + result.good + result.verygood + result.excellent)
        }
        if (result.verygood == 0) {
          this.verygood = 0;
        } else {
          this.verygood = result.verygood / (result.poor + result.average + result.good + result.verygood + result.excellent)
        }
        if (result.excellent == 0) {
          this.excellent = 0;
        } else {
          this.excellent = result.excellent / (result.poor + result.average + result.good + result.verygood + result.excellent)
        }
        console.log(this.poor, this.average, this.good, this.verygood, this.excellent)
      }, (error: any) => {
        console.log("error logs", error)
      });
  }
  //added by Parul for getting Review on particular Product
  getReview() {
    let formdata = {
      productId: this.productId
    }
    this.service.getReview(formdata).subscribe((result: any) => {
      // console.log("recommended Products",result[0].name)
      this.review = result[0].message;
      this.review1 = result[1].message;
      console.log("Reviews", result)
    }, (error: any) => {
      console.log("error log", error)
    });
  }
 
  notifications() {
    this.router.navigate(['/'])
  }
  processCheckout() {
    this.router.navigate(['./cart/'])
    this.recommandedProductList()
  }




///Added by Divyansh Sharma to check the cart item
  go(productObj){
    console.log("productObj ", productObj)
    this.cart = []
    let cart = localStorage.getItem("cart");
    if (cart) {
      this.cart = JSON.parse(cart);
      console.log("cart ", this.cart)
      let filtered = this.cart.filter(product => product.id == productObj._id)
      console.log("filtered ", filtered)
      if (filtered.length == 0) {
        return true
  }
  else{
    return false;
  }}}


////Added by Divyansh Sharma to check the cart item
goo(productObj){
  console.log("productObj ", productObj)
  this.cart = []
  let cart = localStorage.getItem("cart");
  if (cart) {
    this.cart = JSON.parse(cart);
    console.log("cart ", this.cart)
    let filtered = this.cart.filter(product => product.id == productObj._id)
    console.log("filtered ", filtered)
    if (filtered.length == 0) {
      return false
}
else{
  return true;
}

}}

////Added by Divyansh Sharma to detect the image error
handleMissingImage($event){
  console.log($event)
  console.log("hello error");
  ($event.target as HTMLImageElement).style.display = 'none'
  this.a=true;
}
home(){
  this.router.navigate(['/'])
}
isActive(){
  if(localStorage.getItem('retailerEnabled')=="1")
  {
     return true
  }
}
selectImage(image:any){
console.log("click image",image)
this.selectSingleImage=image;

}
AddToWishlist(proId:any) {
  let formdata={
    userId:localStorage.getItem("userId"),
    productId:proId
  }
  let user=localStorage.getItem("userId")
  if(user=="undefined"){
    this.addedToWishlist = false;
    console.log("please login")
    this.router.navigate(["/login"])
  }
  else{
    console.log(" done login")
    console.log("id of user",formdata)
    this.addedToWishlist = true;
  this.service.addToWishlist1(formdata).subscribe(() => {
    console.log("add wish",this.addedToWishlist)
    this.toastService.presentToast("Added to your Wishlist")
  })
  }
  this.ionViewWillEnter1()
}
deleteWishlist(proId:any){
  let array={
    userId:this.userId,
    productId:proId
  }
  
  this.service.deleteWish(array).subscribe(()=>{
    console.log();
    this.addedToWishlist=false;
    console.log("remove wish",this.addedToWishlist)
    this.toastService.presentToast("Removed from your Wishlist")
  })
  this.ionViewWillEnter1()
 }
 cartPage() {
  this.router.navigate(['/cart'])
}
ionViewWillEnter1(){
  this.a=this.userService.uid;
  if(this.a){
    this.check=true;
  }else{
    this.check=false
  }
  let data={
    uid : this.a
  }
  this.userService.getUserDetails(data).subscribe((res:any)=>{
    console.log("userDetails",res);
    if(res){
      this.userId=res._id
      localStorage.setItem("userId", this.userId)
      console.log("dsfdg", this.userId)
    }
   
  })
}
}


